import { createSlice } from '@reduxjs/toolkit';
import { Status } from '../../projects/projectsSlice';

const ReceiveSlice = createSlice({
  name: 'receiveHours',
  initialState: {
    data: [],
    searchResults: [],
    receive: {
      status: Status.idle,
      loading: false,
      data: {},
      error: '',
    },
    error: '',
    status: Status.idle,
    loading: false,
  },
  reducers: {
    resetReceiveHours: (state) => {
      state.data = [];
      state.receive = {
        status: Status.idle,
        loading: false,
        data: {},
        error: '',
      };
      state.error = '';
      state.status = Status.idle;
      state.loading = false;
    },
    resetReceiveHour: (state) => {
      state.receive = {
        status: Status.idle,
        loading: false,
        data: {},
        error: '',
      };
    },
  },
});

const actions = ReceiveSlice.actions;

export { actions };
export default ReceiveSlice.reducer;
